import { useEffect, useMemo, useState } from "react";
import { Badge, Container } from "reactstrap";
import { format } from "date-fns";

import useFetch from "Hooks/useFetch";
import ReactTable from "components/ReactTable/ReactTable";
import DefaultColumnFilter from "components/ReactTable/Components/DefaultColumnFilter/DefaultColumnFilter";
import styles from "Pages/Admin/AgentStatus/AgentStatus.module.css";
import usePageTitle from "Hooks/usePageTitle";

interface IStatuses {
    company_id: string;
    is_online: boolean;
    last_connection: string;
    lost_connection_time: string | null;
    registration_time: string;
    server: string;
    tag: string;
    version: string;
}

export default function AgentStatus() {
    const [statuses, setStatuses] = useState<IStatuses[]>([]);
    const [isLoading, setIsLoading] = useState(false);

    usePageTitle("Agent Status");
    const { get } = useFetch();

    // Get all agent statuses
    useEffect(() => {
        let ignore = false;

        getStatus();

        async function getStatus() {
            setIsLoading(true);
            const response = await get(`/api/agent_status/all`);

            let data: any;
            try {
                data = await response.json();
            } catch {
                data = response;
            }
            console.log("Agent statuses response: ", data);

            if (response.ok && !ignore) {
                setStatuses(data);
            }
            setIsLoading(false);
        }

        return () => {
            ignore = true;
        };
    }, [get]);

    const columns = useMemo(
        () => [
            {
                Header: "Company",
                accessor: "company_id",
                Filter: ({ column }: { column: any }) => (
                    <DefaultColumnFilter column={column} autoFocus />
                ),
            },
            {
                Header: "Online",
                accessor: "is_online",
                width: 60,
                Cell: ({ value }: { value: boolean }) => (
                    <Badge
                        className={styles.badge}
                        color={value ? "success" : "danger"}
                        pill
                    >
                        {value ? "True" : "False"}
                    </Badge>
                ),
            },
            {
                Header: "Server",
                accessor: "server",
                width: 80,
            },
            {
                Header: "Tag",
                accessor: "tag",
                width: 60,
            },
            {
                Header: "Agent Version",
                accessor: "version",
                width: 80,
            },
            {
                Header: "Last Registration",
                accessor: "registration_time",
                width: 100,
                Cell: ({ value }: { value: string }) =>
                    format(new Date(value), "MMM dd, yyyy HH:mm"),
            },
            {
                Header: "Last Connection",
                accessor: "last_connection",
                width: 100,
                Cell: ({ value }: { value: string }) =>
                    format(new Date(value), "MMM dd, yyyy HH:mm"),
            },
        ],
        []
    );

    const tableProps = {
        data: statuses,
        columns,
        showPagination: true,
        isLoading,
    };
    return (
        <Container fluid>
            <h1>Agent Status</h1>
            <ReactTable {...tableProps} />
        </Container>
    );
}
